








































import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import TimeLineItemText from "@/components/utility/TimeLineItemText.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";

@Component({
  components: { TimeLineItemText, TimelineCard }
})
export default class RepairEstimateResponseCardHistory extends mixins(PermissionMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly formatCurrency = formatCurrency;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = RepairEstimate.statusIconMap;

  readonly statusColorMap = RepairEstimate.statusColorMap;

  @Prop()
  value!: IRepairEstimate;
}
